/**
 * @file add-square.tsx
 * @description Компонент для отображения иконки круглого закрытия файла.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const CloseFileRoundIcon = ({ className, color = '#045A9A', onClick }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick}>
            <svg
                width="1.482vmin"
                height="1.5878vmin"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="7" cy="7.5" r="7" fill={color} />
                <path d="M4.375 4.875L9.625 10.125" stroke="white" strokeWidth="0.9375" strokeLinecap="round" />
                <path d="M4.375 10.125L9.625 4.875" stroke="white" strokeWidth="0.9375" strokeLinecap="round" />
            </svg>
        </div>
    );
};
